
import { Link } from "react-router-dom";
import { scrollToTop } from "@/utils/navigation";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";

interface NavbarDesktopMenuProps {
  scrollToServices: () => void;
}

export const NavbarDesktopMenu = ({ scrollToServices }: NavbarDesktopMenuProps) => {
  const services = [
    { title: "Washer Repair", path: "/services/washer-repair" },
    { title: "Dryer Repair", path: "/services/dryer-repair" },
    { title: "Dishwasher Repair", path: "/services/dishwasher-repair" },
    { title: "Stove Repair", path: "/services/stove-repair" },
    { title: "Refrigerator Repair", path: "/services/refrigerator-repair" },
    { title: "Oven Repair", path: "/services/oven-repair" },
  ];

  return (
    <div className="flex items-center space-x-4">
      <Link 
        to="/" 
        className="hover:text-primary transform hover:scale-110 transition-all duration-300"
        onClick={scrollToTop}
      >
        Home
      </Link>
      <NavigationMenu className="-mx-4">
        <NavigationMenuList>
          <NavigationMenuItem>
            <NavigationMenuTrigger 
              className="text-white hover:text-primary transform hover:scale-110 transition-all duration-300 bg-transparent text-base font-normal h-8 px-2"
              onClick={(e) => {
                e.preventDefault();
                scrollToServices();
              }}
            >
              Our Services
            </NavigationMenuTrigger>
            <NavigationMenuContent>
              <div className="grid gap-2 p-4 w-[200px] bg-white">
                {services.map((service, index) => (
                  <Link
                    key={index}
                    to={service.path}
                    className="block px-4 py-2 hover:bg-primary/20 rounded-md transform hover:scale-105 transition-all duration-300 text-black"
                  >
                    {service.title}
                  </Link>
                ))}
              </div>
            </NavigationMenuContent>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>
      <Link to="/advantages" className="hover:text-primary transform hover:scale-110 transition-all duration-300">
        FAQ
      </Link>
      <Link to="/about" className="hover:text-primary transform hover:scale-110 transition-all duration-300">
        About
      </Link>
      <Link to="/contact" className="hover:text-primary transform hover:scale-110 transition-all duration-300 ml-2">
        Contact
      </Link>
    </div>
  );
};
